import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import cx from 'classnames';
const SingleHeroVideoWistia = t0 => {
  const $ = _c(5);
  const {
    autoplay,
    isAdmin,
    videoId: t1
  } = t0;
  const videoId = t1 === undefined ? "kwykvxwggps" : t1;
  const [isThumbnailLoaded, setIsThumbnailLoaded] = useState(false);
  if (isAdmin) {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="min-h-[596px]">JB Single Hero Video Placeholder for Variant Builder. <br />The component will display correctly in Consumer</div>;
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    return t2;
  }
  let t2;
  if ($[1] !== autoplay || $[2] !== isThumbnailLoaded || $[3] !== videoId) {
    t2 = !!videoId && <><Helmet><script src={`//fast.wistia.com/embed/medias/${videoId}.jsonp`} async={true} /><script src="//fast.wistia.com/assets/external/E-v1.js" async={true} /></Helmet><div className="SingleHeroVideoCore"><div className="px-0 py-[56.25%0] relative"><div className="h-full left-0 top-0 w-full"><div className={`wistia_embed wistia_async_${videoId} videoFoam=true muted=true autoPlay=${autoplay === true ? "true" : "false"} playbar=false qualityControl=false settingsControl=false smallPlayButton=false fullscreenButton=false silentAutoPlay=allow googleAnalytics=false endVideoBehavior=reset w-full h-full relative`}><div className={cx("wistia_swatch h-full left-0 opacity-0 overflow-hidden absolute top-0 [transition:opacity_.2s] w-full", {
                "opacity-100": !!isThumbnailLoaded
              })}><img className="[filter:blur(5px)] h-full object-contain w-full" src={`//fast.wistia.com/embed/medias/${videoId}/swatch`} alt="" aria-hidden="true" onLoad={() => {
                  setIsThumbnailLoaded(true);
                }} /></div></div></div></div></div></>;
    $[1] = autoplay;
    $[2] = isThumbnailLoaded;
    $[3] = videoId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
SingleHeroVideoWistia.propTypes = {
  autoplay: PropTypes.bool,
  isAdmin: PropTypes.bool,
  videoId: PropTypes.string
};
export default SingleHeroVideoWistia;